import { Controller, useFormContext } from 'react-hook-form';
import _ from 'lodash';
import CustomSelectInput from '../../CustomSelectInput/CustomSelectInput';
import { SelectField } from '../types';

const SelectFieldForm = ({ field }: { field: SelectField }) => {
  const {
    control,
    formState: { errors },
    setValue,
    getValues,
  } = useFormContext();
  const currentError = _.get(errors, field.key);
  return (
    <div>
      <Controller
        name={field.key}
        control={control}
        render={({ field: renderField }) => (
          <CustomSelectInput
            label={field.label}
            options={field.options as any}
            value={renderField.value}
            isDisabled={field.disabled as boolean}
            placeholder={field.placeholder}
            onChange={(newValue) => {
              renderField.onChange(newValue);
              field.onAfterChange?.(newValue, { setValue, getValues });
            }}
          />
        )}
      />
      {currentError && <p className="text-danger" style={{ fontSize: 12 }}>{(currentError as any).message}</p>}
    </div>
  );
};

export default SelectFieldForm;
